module.exports = __webpack_public_path__ + "static/img/10001 (2).ba10d72.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (2).webp
// module id = qhY1
// module chunks = 14